<!--
	ReviewList.svelte

    08/02 - converting this to use common <ListHeader> and <ListActionBar>

    TODO:

        need actions object
        need headerCells object

    JSON as of 8/25/22

    {
        createdAt: "2022-08-25T13:58:16.612533Z"
        createdServiceID: null
        dateAssigned: null
        dateSubmitted: "2022-08-25T13:58:13.674656Z"
        date_accepted: null
        date_rejected: null
        finalService: null

        flags: [{
            createdAt: "0001-01-01T00:00:00Z"
            description: "intake func failed to establish connection with main website"
            flagName: "main-website-error-intake"
            id: 5
            updatedAt: "0001-01-01T00:00:00Z"
        }]

        id: "3eecd13c-ebfc-4350-93a1-f1e79f71fd7c"
        leftServiceIds: null
        leftServices: null
        reviewSubType: "human"
        reviewType: "create"
        reviewerId: null

        rightService: {id: null, createdAt: '0001-01-01T00:00:00Z', updatedAt: '0001-01-01T00:00:00Z', 
            serviceName: "Andy's new service AAA", 
            description: 'this is the description', 
            ...
        }

        status: "pending"
        submitterId: "222cb581-c23c-4fd8-8bdf-44c32ca39545"
        submitterName: "Andy Knoll"
        taskId: null
        taskSummary: null
        updatedAt: "2022-08-25T13:58:16.612536Z"
    }
        
-->

<script>
    import { onMount } from 'svelte';
    import { ROLE_SUBMITTER } from '../../common/roles-actions.js';
    import { getSelectedItems, sortArrayItems } from '../../common/utils.js';
    import { approveReviews2, rejectReviews2} from '../../api/services.ts';
    import { setInfoAlert, setErrorAlert, PENDING_MSECS } from '../../stores/AlertsStore';

    // TCARE components
    import ReviewListItem from './ReviewListItem.svelte';
	import ListHeader from './ListHeader.svelte';
	import ListActionBar from './ListActionBar.svelte';

    // SMUI components

    // cannot export these from a component! use utils.js?
    const CELL_CHECKBOX = 'cell-checkbox';
    const CELL_STANDARD = 'cell-standard';
    const CELL_SORTABLE = 'cell-sortable';
    const CELL_DIVIDER  = 'cell-divider';

    const APPROVE_PENDING_MSG = 'Submitting your Approve requests - click to cancel';
    const APPROVE_ERROR_MSG = 'Error while submitting your Approve requests';
    const APPROVE_SUCCESS_MSG = 'Successfully submitted your Approve requests';
    const REJECT_PENDING_MSG = 'Submitting your Reject requests - click to cancel';
    const REJECT_ERROR_MSG = 'Error while submitting your Reject requests';
    const REJECT_SUCCESS_MSG = 'Successfully submitted your Reject requests';

    export let items;
    export let onEditReview;                // pass-thru to ListItem
    
    $: sortedItems = items;
    $: selectedIds = getSelectedItems(sortedItems).map(el => el.id);
    $: selectedCount = 0;
    $: isAllSelected = false;

    onMount(() => {
    })

    const sortItems = (propName, isAscending) => {
        sortArrayItems(items, propName, isAscending);
        sortedItems = items;            // Svelte refresh
    }

    const setSelectedCount = () => {
        selectedCount = 0;
        if (!sortedItems) return;
        for (const item of sortedItems) {
            if (item.isSelected) selectedCount++;
        }
    }

    const onHeaderCheckboxClick = () => {
        isAllSelected = !isAllSelected;
        selectAllItems(isAllSelected);
    }

    const onItemCheckboxClick = (item) => {
        item.isSelected = !item.isSelected;
        setSelectedCount();
    }

    const selectAllItems = (val) => {
        for (const item of sortedItems) {
            item.isSelected = false;                  // unselect all
            if (item['reviewType'] !== 'merge') {       // merges cannot be selected
                item.isSelected = val;
            }
        }
        setSelectedCount();
        sortedItems = sortedItems;          // Svelte refresh
    }

    // for the <ListHeader> component - must end styles with ";"

    const headerCells = [
        {
            type: CELL_CHECKBOX, 
            style: 'width: 5%;',
            onCheckboxClick: onHeaderCheckboxClick,
            align: 'center'
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 37%;',
            label: 'Summary/Name', 
            propName: 'taskSummary', 
            onSort: sortItems,
            align: 'left',
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 10%;',
            label: 'Flags', 
            propName: '', 
            onSort: sortItems,
            align: 'center',
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 10%;',
            label: 'Task ID', 
            propName: 'taskId', 
            onSort: sortItems,
            align: 'center',
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 10%;',
            label: 'Status', 
            propName: 'status', 
            onSort: sortItems,
            align: 'center',
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 10%;',
            label: 'Submitted', 
            propName: 'dateSubmitted', 
            onSort: sortItems,
            align: 'center',
        },
        {   type: CELL_DIVIDER, align: '', style: '' },
        {
            type: CELL_SORTABLE, 
            style: 'width: 15%;',
            label: 'Submitter Name', 
            propName: 'submitterName', 
            onSort: sortItems,
            align: 'right'
        }
    ]


    // 8/22 new API format per Vito
    /*
    {
        ids: ["123"], // review ids
        containsReviewerInput: true,
        finalServices: {  // map of review ids to service data
            "123": {
                id: 123131,
                serviceName: "abcco",
                // rest of fields
            }
        }
    }
    */

    // see ReviewPage onApproveReview
    // see AuthSearchResultsList flagDupes
    const approveSel = () => {
        selectedIds = getSelectedItems(sortedItems).map(el => el.id);
        const body = {ids: selectedIds};

        // CALL API HERE!
        // passing in the function - will not run if Alert is cancelled
        setInfoAlert(APPROVE_PENDING_MSG, PENDING_MSECS, async () => {
            let json = await approveReviews2(body);
            if (!json.errors) {
                setInfoAlert(APPROVE_SUCCESS_MSG, 2000);
                //pop();
            } else {
                setErrorAlert(APPROVE_ERROR_MSG, 2000);         // based on API success
            }
            selectAllItems(false);
        });
    }

    // see ReviewPage onRejectReview
    const rejectSel = () => {
        selectedIds = getSelectedItems(sortedItems).map(el => el.id);
        const body = {ids: selectedIds};

        // CALL API HERE!
        // passing in the function - will not run if Alert is cancelled
        setInfoAlert(REJECT_PENDING_MSG, PENDING_MSECS, async () => {
            let json = await rejectReviews2(body);
            if (!json.errors) {
                setInfoAlert(REJECT_SUCCESS_MSG, 2000);
                //pop();
            } else {
                setErrorAlert(REJECT_ERROR_MSG, 2000);         // based on API success
            }
            selectAllItems(false);
        });
    }

    // const action1 = () => {
    //     console.log('running ReviewList action1');
    // }

    // const action2 = () => {
    //     console.log('running ReviewList action2');
    // }

    // const action3 = () => {
    //     console.log('running ReviewList action3');
    // }

    const actions = [
        {action: approveSel, label: 'Approve Selected', roles: [ROLE_SUBMITTER]},
        {action: rejectSel, label: 'Reject Selected', roles: [ROLE_SUBMITTER]},
        // {action: action1, label: 'SEARCH action1', roles: [ROLE_SEARCH]},
        // {action: action2, label: 'READ action2', roles: [ROLE_READ]},
        // {action: action3, label: 'WRITE action2', roles: [ROLE_REVIEW_WRITE]}
    ]

</script>

<style>
    .review-list {
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="review-list">
    <ListHeader {headerCells} />
    <ListActionBar {actions} {selectedCount} />
    {#each sortedItems as item, index}
        <ReviewListItem {item} {index} 
            onCheckboxClick={onItemCheckboxClick} 
            isCheckbox={item['reviewType'] !== 'merge'}
            {onEditReview} 
        />
    {/each}

</div>
